import { useEffect, useState } from "react";
import singleMemberLLCServices from "../../services/SingleMemberLLCService";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Modal as Model2 } from "antd";
import { useNavigate, Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Lodder from "../../components/Lodder";
import InputMask from "react-input-mask";
import CryptoJS from "crypto-js";
import { Button, notification } from "antd";
import { CloseOutlined } from '@ant-design/icons';
const SingleMemberLLCForm = () => {
  // #region GetEncryptedQueryParamData
  const encryptedQueryParam = useParams().customerServiceData;
  const decryptedData = CryptoJS.AES.decrypt(
    decodeURIComponent(encryptedQueryParam),
    process.env.REACT_APP_SECRET_KEY
  ).toString(CryptoJS.enc.Utf8);
  const customerServiceData = JSON.parse(decryptedData);

  // #endregion

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [toggle, setToggle] = useState(1);
  const [toggle2, setToggle2] = useState(1);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    /* border: "2px solid #000", */
    boxShadow: 24,
    p: 2,
  };
  useEffect(() => {
    if (toggle !== 1) {
      ValidateOtherRegisteredAgent(otherRegisteredAgent);
      ValidateOptionForRegisteredAgent(optionForRegisteredAgent);
      ValidateReasonTermOfLLC(reasonTermOfLLC);
      ValidateTermOfLLC(termOfLLC);
      ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC);
      ValidateReasonForEffectiveDate(reasonForEffectiveDate);
      ValidateEffectiveDateForLLC(effectiveDateForLLC);
      ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating);
      ValidateMailingAddressForBusiness(mailingAddressForBusiness);
      ValidatePreferredPhoneNumber(preferredPhoneNumber);
      ValidatePreferredContactEmail(preferredContactEmail);
      ValidateIsSeparateMailingAddress(isSeparateMailingAddress);
      ValidatePrincipalAddress(principalAddress);
      ValidateBusinessManagers(businessManagers);
      ValidatePrimaryBusiness(primaryBusiness);
      ValidateCompanyWithLLC(companyWithLLC);
      ValidateSubmissionUpdates(submissionUpdates);
      if (
        ValidateOtherRegisteredAgent(otherRegisteredAgent) &&
        ValidateOptionForRegisteredAgent(optionForRegisteredAgent) &&
        ValidateReasonTermOfLLC(reasonTermOfLLC) &&
        ValidateTermOfLLC(termOfLLC) &&
        ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC) &&
        ValidateReasonForEffectiveDate(reasonForEffectiveDate) &&
        ValidateEffectiveDateForLLC(effectiveDateForLLC) &&
        ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating) &&
        ValidateMailingAddressForBusiness(mailingAddressForBusiness) &&
        ValidatePreferredPhoneNumber(preferredPhoneNumber) &&
        ValidatePreferredContactEmail(preferredContactEmail) &&
        ValidateIsSeparateMailingAddress(isSeparateMailingAddress) &&
        ValidatePrincipalAddress(principalAddress) &&
        ValidateBusinessManagers(businessManagers) &&
        ValidatePrimaryBusiness(primaryBusiness) &&
        ValidateCompanyWithLLC(companyWithLLC) &&
        ValidateSubmissionUpdates(submissionUpdates)
      ) {
        handleSubmit();
      }
      setIsSubmitted(false)
    }
  }, [toggle]);
  useEffect(() => {
    debugger
    if (toggle2 !== 1) {
      ValidateOtherRegisteredAgent(otherRegisteredAgent);
    ValidateOptionForRegisteredAgent(optionForRegisteredAgent);
    ValidateReasonTermOfLLC(reasonTermOfLLC);
    ValidateTermOfLLC(termOfLLC);
    ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC);
    ValidateReasonForEffectiveDate(reasonForEffectiveDate);
    ValidateEffectiveDateForLLC(effectiveDateForLLC);
    ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating);
    ValidateMailingAddressForBusiness(mailingAddressForBusiness);
    ValidatePreferredPhoneNumber(preferredPhoneNumber);
    ValidatePreferredContactEmail(preferredContactEmail);
    ValidateIsSeparateMailingAddress(isSeparateMailingAddress);
    ValidatePrincipalAddress(principalAddress);
    ValidateBusinessManagers(businessManagers);
    ValidatePrimaryBusiness(primaryBusiness);
    ValidateCompanyWithLLC(companyWithLLC);
    ValidateSubmissionUpdates(submissionUpdates);
    if (
      ValidateOtherRegisteredAgent(otherRegisteredAgent) &&
      ValidateOptionForRegisteredAgent(optionForRegisteredAgent) &&
      ValidateReasonTermOfLLC(reasonTermOfLLC) &&
      ValidateTermOfLLC(termOfLLC) &&
      ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC) &&
      ValidateReasonForEffectiveDate(reasonForEffectiveDate) &&
      ValidateEffectiveDateForLLC(effectiveDateForLLC) &&
      ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating) &&
      ValidateMailingAddressForBusiness(mailingAddressForBusiness) &&
      ValidatePreferredPhoneNumber(preferredPhoneNumber) &&
      ValidatePreferredContactEmail(preferredContactEmail) &&
      ValidateIsSeparateMailingAddress(isSeparateMailingAddress) &&
      ValidatePrincipalAddress(principalAddress) &&
      ValidateBusinessManagers(businessManagers) &&
      ValidatePrimaryBusiness(primaryBusiness) &&
      ValidateCompanyWithLLC(companyWithLLC) &&
      ValidateSubmissionUpdates(submissionUpdates)
    ) {
      setOpen(true);
    }
    }
  }, [toggle2]);
 
  const navigate = useNavigate();
  /* const[submit,setSubmit]=useState(true) */
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    debugger
    setIsSubmitted(true)
    setToggle2(toggle2+1)
    
  }
  const handleCancel = () => {
    setOpen(false);
  };
  const handleOk = () => {
    setOpen(false);
    setToggle(toggle + 1);
    setIsSubmitted(true);
  };
  const [id, setId] = useState("");
  useEffect(() => {
    singleMemberLLCServices
      .GetCustomerServiceQuestionByCustomerIdAndServiceId(
        customerServiceData.customerServiceId
      )
      .then((response) => {
        debugger
        if (response.status) {
          const { resultData } = response;
          if (resultData !== null) {
            setReadOnly(resultData.isSubmitted);
            setId(resultData.id);
            setSubmissionUpdates(resultData.submissionUpdates);
            setCompanyWithLLC(resultData.companyWithLLC);
            setPrimaryBusiness(resultData.primaryBusiness);
            setBusinessManagers(resultData.businessManagers);
            setPrincipalAddress(resultData.principalAddress);
            debugger
            if(resultData.isSeparateMailingAddress!==null)
            { debugger
              setIsSeparateMailingAddress(
                resultData.isSeparateMailingAddress.toString()
              );
            }
            setPreferredContactEmail(resultData.preferredContactEmail);
            setPreferredPhoneNumber(resultData.preferredPhoneNumber);
            if(resultData.isSeparateMailingAddress)
            { 
              setMailingAddressForBusiness(resultData.mailingAddressForBusiness);
            }
            setIsEffectiveDateForCreating(
              resultData.isEffectiveDateForCreating.toString()
            );
            setEffectiveDateForLLC(resultData.effectiveDateForLLC);
            setReasonForEffectiveDate(resultData.reasonForEffectiveDate);
            setPerpetualTermForTheLLC(
              resultData.perpetualTermForTheLLC.toString()
            );
            setTermOfLLC(resultData.termOfLLC);
            setReasonTermOfLLC(resultData.reasonTermOfLLC);
            setOptionForRegisteredAgent(
              resultData.optionForRegisteredAgent.toString()
            );
            setOtherRegisteredAgent(resultData.otherRegisteredAgent);
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    document.title = "Single Member LLC Form";
  }, []);
  const [readOnly, setReadOnly] = useState(false);

  const [submissionUpdates, setSubmissionUpdates] = useState("");
  const [companyWithLLC, setCompanyWithLLC] = useState("");
  const [primaryBusiness, setPrimaryBusiness] = useState("");
  const [businessManagers, setBusinessManagers] = useState("");
  const [principalAddress, setPrincipalAddress] = useState("");
  const [isSeparateMailingAddress, setIsSeparateMailingAddress] = useState("");
  const [preferredContactEmail, setPreferredContactEmail] = useState("");
  const [preferredPhoneNumber, setPreferredPhoneNumber] = useState("");
  const [mailingAddressForBusiness, setMailingAddressForBusiness] =
    useState("");
  const [isEffectiveDateForCreating, setIsEffectiveDateForCreating] =
    useState("");
  const [effectiveDateForLLC, setEffectiveDateForLLC] = useState("");
  const [reasonForEffectiveDate, setReasonForEffectiveDate] = useState("");
  const [perpetualTermForTheLLC, setPerpetualTermForTheLLC] = useState("");
  const [termOfLLC, setTermOfLLC] = useState("");
  const [reasonTermOfLLC, setReasonTermOfLLC] = useState("");
  const [optionForRegisteredAgent, setOptionForRegisteredAgent] = useState("");
  const [otherRegisteredAgent, setOtherRegisteredAgent] = useState("");
  const [submissionUpdatesValidation, setSubmissionUpdatesValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const [companyWithLLCValidation, setCompanyWithLLCValidation] = useState({
    isValid: true,
    message: "",
  });
  const [primaryBusinessValidation, setPrimaryBusinessValidation] = useState({
    isValid: true,
    message: "",
  });
  const [businessManagersValidation, setBusinessManagersValidation] = useState({
    isValid: true,
    message: "",
  });
  const [principalAddressValidation, setPrincipalAddressValidation] = useState({
    isValid: true,
    message: "",
  });
  const [
    isSeparateMailingAddressValidation,
    setIsSeparateMailingAddressValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const [preferredContactEmailValidation, setPreferredContactEmailValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const [preferredPhoneNumberValidation, setPreferredPhoneNumberValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const [
    mailingAddressForBusinessValidation,
    setMailingAddressForBusinessValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const [
    isEffectiveDateForCreatingValidation,
    setIsEffectiveDateForCreatingValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const [effectiveDateForLLCValidation, setEffectiveDateForLLCValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const [
    reasonForEffectiveDateValidation,
    setReasonForEffectiveDateValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const [
    perpetualTermForTheLLCValidation,
    setPerpetualTermForTheLLCValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const [termOfLLCValidation, setTermOfLLCValidation] = useState({
    isValid: true,
    message: "",
  });
  const [reasonTermOfLLCValidation, setReasonTermOfLLCValidation] = useState({
    isValid: true,
    message: "",
  });
  const [
    optionForRegisteredAgentValidation,
    setOptionForRegisteredAgentValidation,
  ] = useState({
    isValid: true,
    message: "",
  });
  const [otherRegisteredAgentValidation, setOtherRegisteredAgentValidation] =
    useState({
      isValid: true,
      message: "",
    });
  const handleSubmissionUpdates = (event) => {
    setSubmissionUpdates(event.target.value);
    ValidateSubmissionUpdates(event.target.value);
  };
  const handleCompanyWithLLC = (event) => {
    setCompanyWithLLC(event.target.value);
    ValidateCompanyWithLLC(event.target.value);
  };
  const handlePrimaryBusiness = (event) => {
    setPrimaryBusiness(event.target.value);
    ValidatePrimaryBusiness(event.target.value);
  };
  const handleBusinessManagers = (event) => {
    setBusinessManagers(event.target.value);
    ValidateBusinessManagers(event.target.value);
  };
  const handlePrincipalAddress = (event) => {
    setPrincipalAddress(event.target.value);
    ValidatePrincipalAddress(event.target.value);
  };
  const handleIsSeparateMailingAddress = (event) => {
    setIsSeparateMailingAddress(event.target.value);
    ValidateIsSeparateMailingAddress(event.target.value);
  };
  const handlePreferredContactEmail = (event) => {
    setPreferredContactEmail(event.target.value);
    ValidatePreferredContactEmail(event.target.value);
  };
  const handlePreferredPhoneNumber = (event) => {
    setPreferredPhoneNumber(event.target.value);
    ValidatePreferredPhoneNumber(event.target.value);
  };
  const handleMailingAddressForBusiness = (event) => {
    setMailingAddressForBusiness(event.target.value);
    ValidateMailingAddressForBusiness(event.target.value);
  };
  const handleIsEffectiveDateForCreating = (event) => {
    setIsEffectiveDateForCreating(event.target.value);
    ValidateIsEffectiveDateForCreating(event.target.value);
  };
  const handleEffectiveDateForLLC = (event) => {
    setEffectiveDateForLLC(event.target.value);
    ValidateEffectiveDateForLLC(event.target.value);
  };
  const handleReasonForEffectiveDate = (event) => {
    setReasonForEffectiveDate(event.target.value);
    ValidateReasonForEffectiveDate(event.target.value);
  };
  const handlePerpetualTermForTheLLC = (event) => {
    setPerpetualTermForTheLLC(event.target.value);
    ValidatePerpetualTermForTheLLC(event.target.value);
  };
  const handleTermOfLLC = (event) => {
    setTermOfLLC(event.target.value);
    ValidateTermOfLLC(event.target.value);
  };
  const handleReasonTermOfLLC = (event) => {
    setReasonTermOfLLC(event.target.value);
    ValidateReasonTermOfLLC(event.target.value);
  };
  const handleOptionForRegisteredAgent = (event) => {
    setOptionForRegisteredAgent(event.target.value);
    ValidateOptionForRegisteredAgent(event.target.value);
  };
  const handleOtherRegisteredAgent = (event) => {
    setOtherRegisteredAgent(event.target.value);
    ValidateOtherRegisteredAgent(event.target.value);
  };
  const IsValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };
  const ValidateSubmissionUpdates = (value) => {
    if (!value.trim() /* && isSubmitted */) {
      setSubmissionUpdatesValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setSubmissionUpdatesValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else if (!IsValidEmail(value) /* && isSubmitted */) {
      setSubmissionUpdatesValidation({
        isValid: false,
        message: "Email format not correct",
      });
      return false;
    } else {
      setSubmissionUpdatesValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateCompanyWithLLC = (value) => {
    if (!value.trim() && isSubmitted) {
      setCompanyWithLLCValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setCompanyWithLLCValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else {
      setCompanyWithLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidatePrimaryBusiness = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrimaryBusinessValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setPrimaryBusinessValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else {
      setPrimaryBusinessValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateBusinessManagers = (value) => {
    if (!value.trim() && isSubmitted) {
      setBusinessManagersValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setBusinessManagersValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else {
      setBusinessManagersValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidatePrincipalAddress = (value) => {
    if (!value.trim() && isSubmitted) {
      setPrincipalAddressValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 500) {
      setPrincipalAddressValidation({
        isValid: false,
        message: "Don't enter more than 500 character",
      });
      return false;
    } else {
      setPrincipalAddressValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateIsSeparateMailingAddress = (value) => {
    if (!value.trim() && isSubmitted) {
      setIsSeparateMailingAddressValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setIsSeparateMailingAddressValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidatePreferredContactEmail = (value) => {
    if (!value.trim() /* && isSubmitted */) {
      setPreferredContactEmailValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 100) {
      setPreferredContactEmailValidation({
        isValid: false,
        message: "Don't enter more than 100 character",
      });
      return false;
    } else if (!IsValidEmail(value) /* && isSubmitted */) {
      setPreferredContactEmailValidation({
        isValid: false,
        message: "Email format not correct",
      });
      return false;
    } else {
      setPreferredContactEmailValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidatePreferredPhoneNumber = (value) => {
    if (!value.trim() && isSubmitted) {
      setPreferredPhoneNumberValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else if (value.length > 20) {
      setPreferredPhoneNumberValidation({
        isValid: false,
        message: "Don't enter more than 20 character",
      });
      return false;
    } else {
      setPreferredPhoneNumberValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateMailingAddressForBusiness = (value) => {
    if (isSeparateMailingAddress === "true") {
      if (!value.trim() /* && isSubmitted */) {
        setMailingAddressForBusinessValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 100) {
        setMailingAddressForBusinessValidation({
          isValid: false,
          message: "Don't enter more than 100 character",
        });
        return false;
      } else if (!IsValidEmail(value) /* && isSubmitted */) {
        setMailingAddressForBusinessValidation({
          isValid: false,
          message: "Email format not correct",
        });
        return false;
      } else {
        setMailingAddressForBusinessValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setMailingAddressForBusinessValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateIsEffectiveDateForCreating = (value) => {
    if (!value.trim() && isSubmitted) {
      setIsEffectiveDateForCreatingValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setIsEffectiveDateForCreatingValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateEffectiveDateForLLC = (value) => {
    if (isEffectiveDateForCreating === "false") {
      if (!value.trim() && isSubmitted) {
        setEffectiveDateForLLCValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 100) {
        setEffectiveDateForLLCValidation({
          isValid: false,
          message: "Don't enter more than 100 character",
        });
        return false;
      } else {
        setEffectiveDateForLLCValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setEffectiveDateForLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateReasonForEffectiveDate = (value) => {
    if (isEffectiveDateForCreating === "false") {
      if (!value.trim() && isSubmitted) {
        setReasonForEffectiveDateValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setReasonForEffectiveDateValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setReasonForEffectiveDateValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setReasonForEffectiveDateValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidatePerpetualTermForTheLLC = (value) => {
    if (!value.trim() && isSubmitted) {
      setPerpetualTermForTheLLCValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setPerpetualTermForTheLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateTermOfLLC = (value) => {
    if (perpetualTermForTheLLC === "2") {
      if (!value.trim() && isSubmitted) {
        setTermOfLLCValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setTermOfLLCValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setTermOfLLCValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setTermOfLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateReasonTermOfLLC = (value) => {
    if (perpetualTermForTheLLC === "2") {
      if (!value.trim() && isSubmitted) {
        setReasonTermOfLLCValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setReasonTermOfLLCValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setReasonTermOfLLCValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setReasonTermOfLLCValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateOptionForRegisteredAgent = (value) => {
    if (!value.trim() && isSubmitted) {
      setOptionForRegisteredAgentValidation({
        isValid: false,
        message: "This field is required",
      });
      return false;
    } else {
      setOptionForRegisteredAgentValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateOtherRegisteredAgent = (value) => {
    if (optionForRegisteredAgent === "3") {
      if (!value.trim() && isSubmitted) {
        setOtherRegisteredAgentValidation({
          isValid: false,
          message: "This field is required",
        });
        return false;
      } else if (value.length > 500) {
        setOtherRegisteredAgentValidation({
          isValid: false,
          message: "Don't enter more than 500 character",
        });
        return false;
      } else {
        setOtherRegisteredAgentValidation({
          isValid: true,
          message: "",
        });
        return true;
      }
    } else {
      setOtherRegisteredAgentValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const handleSubmit = () => {
    debugger
    setShow(true);
    ValidateOtherRegisteredAgent(otherRegisteredAgent);
    ValidateOptionForRegisteredAgent(optionForRegisteredAgent);
    ValidateReasonTermOfLLC(reasonTermOfLLC);
    ValidateTermOfLLC(termOfLLC);
    ValidatePerpetualTermForTheLLC(perpetualTermForTheLLC);
    ValidateReasonForEffectiveDate(reasonForEffectiveDate);
    ValidateEffectiveDateForLLC(effectiveDateForLLC);
    ValidateIsEffectiveDateForCreating(isEffectiveDateForCreating);
    ValidateMailingAddressForBusiness(mailingAddressForBusiness);
    ValidatePreferredPhoneNumber(preferredPhoneNumber);
    ValidatePreferredContactEmail(preferredContactEmail);
    ValidateIsSeparateMailingAddress(isSeparateMailingAddress);
    ValidatePrincipalAddress(principalAddress);
    ValidateBusinessManagers(businessManagers);
    ValidatePrimaryBusiness(primaryBusiness);
    ValidateCompanyWithLLC(companyWithLLC);
    ValidateSubmissionUpdates(submissionUpdates);
    if (
      submissionUpdatesValidation.isValid &&
      companyWithLLCValidation.isValid &&
      primaryBusinessValidation.isValid &&
      businessManagersValidation.isValid &&
      principalAddressValidation.isValid &&
      isSeparateMailingAddressValidation.isValid &&
      preferredContactEmailValidation.isValid &&
      preferredPhoneNumberValidation.isValid &&
      mailingAddressForBusinessValidation.isValid &&
      isEffectiveDateForCreatingValidation.isValid &&
      effectiveDateForLLCValidation.isValid &&
      reasonForEffectiveDateValidation.isValid &&
      perpetualTermForTheLLCValidation.isValid &&
      termOfLLCValidation.isValid &&
      reasonTermOfLLCValidation.isValid &&
      optionForRegisteredAgentValidation.isValid &&
      otherRegisteredAgentValidation.isValid
    ) {
      const form = {
        id: id,
        customerServiceId: customerServiceData.customerServiceId,
        submissionUpdates: submissionUpdates,
        companyWithLLC: companyWithLLC,
        primaryBusiness: primaryBusiness,
        businessManagers: businessManagers,
        principalAddress: principalAddress,
        isSeparateMailingAddress: isSeparateMailingAddress,
        preferredContactEmail: preferredContactEmail,
        preferredPhoneNumber: preferredPhoneNumber,
        mailingAddressForBusiness: mailingAddressForBusiness,
        isEffectiveDateForCreating: isEffectiveDateForCreating,
        effectiveDateForLLC: effectiveDateForLLC,
        reasonForEffectiveDate: reasonForEffectiveDate,
        perpetualTermForTheLLC: perpetualTermForTheLLC,
        termOfLLC: termOfLLC,
        reasonTermOfLLC: reasonTermOfLLC,
        optionForRegisteredAgent: optionForRegisteredAgent,
        otherRegisteredAgent: otherRegisteredAgent,
        isSubmitted: isSubmitted,
      };
      singleMemberLLCServices
        .AddCustomerServiceQuestion(form)
        .then((response) => {
          if (response.status) {
            /* toast.success("Submitted successfully!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }); */if(isSubmitted){
              notification.success({
                message: "Submitted successfully!",
              });
            }else{
              notification.success({
                message: "Saved Successfully!",
              });
            }
            setTimeout(() => {
              navigate("/dashboard");
            }, 2000);
            setShow(false);
          } else {
            setShow(false);
          }
        })
        .catch((error) => {
          /* toast.error(error.response.data.Message); */
          notification.error({
            message: error.response.data.Message,
          });
          console.log(error);
          setShow(false);
        });
    } else {
      setShow(false);
    }
  };
  return (
    <>
      <ToastContainer />
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container my-5 pt-3">
            <div className="row mb-4">
              <div className="col-lg-12">
              {readOnly&&<div className="content-box">
                  <h2 className="text-dark content-title">Note</h2>
                  <p>
                  Your information has been submitted and is being reviewed by Legal Tools staff.
                  </p>
                </div>}
                <div className="content-box ">
                  <h2 className="text-dark content-title">
                    Washington State LLC Registration
                  </h2>
                  <p>
                    The following form contains questions needed for the
                    formation of an LLC in Washington. It is divided into
                    sections and asks questions to provide us the information
                    necessary for:
                  </p>
                  <p>1. Filing an LLC Certificate of Formation; and</p>
                  <p>2. Making an "Initial Report."</p>
                  <p>
                    Please reach out to Kamelia at{" "}
                    <a href="mailto:admin@foundrylawgroup.com" className="text-decoration-none">
                      {" "}
                      admin@gmail.com{" "}
                    </a>{" "}
                    with any questions on completing the form.
                  </p>
                  <span className="d-block">Thanks,</span>
                  <span>Group</span>
                </div>

                <div className="content-box pt-4">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">
                        Please enter the email address where you would like to
                        receive updates about your submission:<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={submissionUpdates}
                        onChange={handleSubmissionUpdates}
                        readOnly={readOnly}
                      />
                      {!submissionUpdatesValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {submissionUpdatesValidation.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Enter the name of your company below (to be followed
                        with ", LLC").<span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={companyWithLLC}
                        onChange={handleCompanyWithLLC}
                        readOnly={readOnly}
                      />
                      {!companyWithLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {companyWithLLCValidation.message}
                        </div>
                      )}
                      <span>
                        E.g., Company Name, LLC. For an LLC, "Inc." is not
                        allowed in a name however it must contain the words
                        "limited liability company," or the abbreviation "L.L.C"
                        or "LLC." Please note we will check for the names but
                        it's good to provide a couple of alternates.
                      </span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is going to be the LLC's primary business?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={primaryBusiness}
                        onChange={handlePrimaryBusiness}
                        readOnly={readOnly}
                      />
                      {!primaryBusinessValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {primaryBusinessValidation.message}
                        </div>
                      )}
                      <span>
                        Please describe the business and the goods and/or
                        services you intend to provide (e.g., online retailing,
                        business consulting, etc.)
                      </span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Who are going to the initial "managers" of the LLC? (See
                        the note below on who should be listed as a manager of
                        an LLC.)
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={businessManagers}
                        onChange={handleBusinessManagers}
                        readOnly={readOnly}
                      />
                      {!businessManagersValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {businessManagersValidation.message}
                        </div>
                      )}
                      <span>
                        A manager of a multi-member LLC is equivalent to the
                        members of a board of director or executive officers of
                        a corporation. These are individuals who have general
                        authority to act on behalf of the LLC, sign contracts,
                        and who are otherwise responsible for the overall
                        business of the LLC. (Note that this is a different
                        definition that the common usage of "manager" as a job
                        title.)
                      </span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What will be the principal address of the business?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={principalAddress}
                        onChange={handlePrincipalAddress}
                        readOnly={readOnly}
                      />
                      {!principalAddressValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {principalAddressValidation.message}
                        </div>
                      )}
                      <span>
                        The place of business is an address for the LLC where
                        the primary business will be conducted. This can be your
                        home address, but will be listed as a public record with
                        the state. The address must be a physical street
                        address. A P.O. Box or PMB will not be accepted. If the
                        address is not in WA State, please note that other
                        state's business licenses may be required. Please enter
                        the full address, city, state, and zip code.
                      </span>
                    </div>
                  </form>
                </div>

                <div className="content-box pt-4">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">
                        Is there a separate mailing address for the business?
                        <span>*</span>
                      </label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isSeparateMailingAddress"
                          id="flexRadioDefault4"
                          value={true}
                          checked={isSeparateMailingAddress === "true"}
                          onChange={handleIsSeparateMailingAddress}
                          disabled={readOnly}
                        />

                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isSeparateMailingAddress"
                          id="flexRadioDefault5"
                          value={false}
                          checked={isSeparateMailingAddress === "false"}
                          onChange={handleIsSeparateMailingAddress}
                          disabled={readOnly}
                        />

                        <label className="form-check-label">No</label>
                      </div>
                      {!isSeparateMailingAddressValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {isSeparateMailingAddressValidation.message}
                        </div>
                      )}
                    </div>
                    {isSeparateMailingAddress === "true" && (
                      <div className="mb-3">
                        <label className="form-label">
                          What will be the mailing address of the business?
                          <span>*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={mailingAddressForBusiness}
                          onChange={handleMailingAddressForBusiness}
                          readOnly={readOnly}
                        />
                        {!mailingAddressForBusinessValidation.isValid && (
                          <div style={{ color: "red" }}>
                            {mailingAddressForBusinessValidation.message}
                          </div>
                        )}
                      </div>
                    )}
                    <div className="mb-3">
                      <label className="form-label">
                        What is the preferred contact email for the business?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={preferredContactEmail}
                        onChange={handlePreferredContactEmail}
                        readOnly={readOnly}
                      />
                      {!preferredContactEmailValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {preferredContactEmailValidation.message}
                        </div>
                      )}
                      <span>A matter of public record</span>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is the preferred phone number for the business?
                        <span>*</span>
                      </label>
                      <InputMask
                        mask="(999) 999-9999"
                        type="text"
                        className="form-control"
                        value={preferredPhoneNumber}
                        onChange={handlePreferredPhoneNumber}
                        readOnly={readOnly}
                      />
                      {!preferredPhoneNumberValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {preferredPhoneNumberValidation.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        Will the effective date for creating the LLC be the date
                        of filing?
                      </label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isEffectiveDateForCreating"
                          id="flexRadioDefault6"
                          value={true}
                          checked={isEffectiveDateForCreating === "true"}
                          onChange={handleIsEffectiveDateForCreating}
                          disabled={readOnly}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="isEffectiveDateForCreating"
                          id="flexRadioDefault7"
                          value={false}
                          checked={isEffectiveDateForCreating === "false"}
                          onChange={handleIsEffectiveDateForCreating}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">
                          No (if no, then you must enter a future date below)
                        </label>
                      </div>
                      {!isEffectiveDateForCreatingValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {isEffectiveDateForCreatingValidation.message}
                        </div>
                      )}
                      <span>
                        The default (and most common) effective date for the
                        company is the date of filing. If you would like to
                        specify a different future (cannot be retroactive) date
                        please specify the date and reason for specifying a
                        different date below.
                      </span>
                    </div>
                    {isEffectiveDateForCreating === "false" && (
                      <>
                        {" "}
                        <div className="mb-3">
                          <label className="form-label">
                            What will be the effective date for the LLC?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={effectiveDateForLLC}
                            onChange={handleEffectiveDateForLLC}
                            readOnly={readOnly}
                          />
                          {!effectiveDateForLLCValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {effectiveDateForLLCValidation.message}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            What is the reason for selecting a future effective
                            date for the LLC?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={reasonForEffectiveDate}
                            onChange={handleReasonForEffectiveDate}
                            readOnly={readOnly}
                          />
                          {!reasonForEffectiveDateValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {reasonForEffectiveDateValidation.message}
                            </div>
                          )}
                          <span>
                            A future date for effectiveness is not very common
                            and only appropriate when there is a specific
                            reason, please indicate the reason you would like a
                            future effective date.
                          </span>
                        </div>
                      </>
                    )}
                    <div className="mb-3">
                      <label className="form-label">
                        By default an LLC is formed to be perpetual (annual
                        renewals still required). In limited cases, a defined
                        term for the LLC may be selected. Please select one of
                        the following option?
                      </label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="perpetualTermForTheLLC"
                          id="flexRadioDefault6"
                          value={1}
                          checked={perpetualTermForTheLLC === "1"}
                          onChange={handlePerpetualTermForTheLLC}
                          disabled={readOnly}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Standard perpetual duration
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="perpetualTermForTheLLC"
                          id="flexRadioDefault7"
                          value={2}
                          checked={perpetualTermForTheLLC === "2"}
                          onChange={handlePerpetualTermForTheLLC}
                          disabled={readOnly}
                        />
                        <label className="form-check-label">
                          Time limited (enter time and reason below)
                        </label>
                      </div>
                      {!perpetualTermForTheLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {perpetualTermForTheLLCValidation.message}
                        </div>
                      )}
                      <span>
                        A defined term for an LLC is not typical and only for
                        special circumstances. A standard perpetual term LLC can
                        still be dissolved.
                      </span>
                    </div>
                    {perpetualTermForTheLLC === "2" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label">
                            What would you like to be the term of the LLC (enter
                            in years or a set end date)?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={termOfLLC}
                            onChange={handleTermOfLLC}
                            readOnly={readOnly}
                          />
                          {!termOfLLCValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {termOfLLCValidation.message}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            What is the reason for selecting a defined term for
                            the LLC?
                            <span>*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={reasonTermOfLLC}
                            onChange={handleReasonTermOfLLC}
                            readOnly={readOnly}
                          />
                          {!reasonTermOfLLCValidation.isValid && (
                            <div style={{ color: "red" }}>
                              {reasonTermOfLLCValidation.message}
                            </div>
                          )}
                        </div>
                      </>
                    )}
                  </form>
                </div>

                <div className="content-box">
                  <h2 className="text-dark content-title">Registered Agent</h2>
                  <p>
                    All entities must have a Registered Agent in Washington
                    State. The Registered Agent can be an individual (such as a
                    member) or a service provider. Group offers one
                    year of registered agent service as part of our formation
                    package ($350/year after the initial year).
                  </p>
                </div>

                <div className="content-box pt-4">
                  <label>
                    Please select a following option for your registered agent.
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="optionForRegisteredAgent"
                      id="flexRadioDefault1"
                      value={1}
                      checked={optionForRegisteredAgent === "1"}
                      onChange={handleOptionForRegisteredAgent}
                      disabled={readOnly}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Group as Registered Agent (initial year is
                      included in formation flat fee)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="optionForRegisteredAgent"
                      id="flexRadioDefault2"
                      value={2}
                      checked={optionForRegisteredAgent === "2"}
                      onChange={handleOptionForRegisteredAgent}
                      disabled={readOnly}
                    />
                    <label className="form-check-label">
                      I'll serve as Registered Agent using the address listed
                      above (Note this address will be publicly listed)
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="optionForRegisteredAgent"
                      id="flexRadioDefault3"
                      value={3}
                      checked={optionForRegisteredAgent === "3"}
                      onChange={handleOptionForRegisteredAgent}
                      disabled={readOnly}
                    />
                    <label className="form-check-label">
                      Other Registered Agent -NOTE: please fill the next section
                      with name, address, and number
                    </label>
                  </div>
                  {!optionForRegisteredAgentValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {optionForRegisteredAgentValidation.message}
                    </div>
                  )}
                  {optionForRegisteredAgent === "3" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Other Registered Agent (our preferred vendor is RASi if
                        you would like to use a corporate service provider)
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={otherRegisteredAgent}
                        onChange={handleOtherRegisteredAgent}
                        readOnly={readOnly}
                      />
                      {!otherRegisteredAgentValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {otherRegisteredAgentValidation.message}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {/* {!readOnly && (
              <div class="d-flex justify-content-center">

              </div>
            )} */}
                {!readOnly && (
                  <div className="d-flex justify-content-center mb-3">
                    <button
                      onClick={() => {
                        Model2.confirm({
                          title: 'Warning',
                          content:'You will lose unsaved changes. Do you want to continue?',
                          footer: (_, { OkBtn }) => (
                            <>
                            <Button className="submit-button text-white" onClick={()=>{navigate(-1);Model2.destroyAll()}} >YES</Button>
                            <Button className="btn-submit-secondary" onClick={()=>{Model2.destroyAll()}} >NO</Button>
                            </>
                          ),
                        });
                        /* navigate(-1) */}}
                      className="btn-submit-secondary btn me-3"
                    >
                      CANCEL
                    </button>
                    <button
                      className="btn-submit-secondary btn me-3"
                      onClick={() => {
                        setToggle(toggle + 1);
                        setIsSubmitted(false);
                      }}
                    >
                      SAVE AS DRAFT
                    </button>
                    <button
                      className="submit-button btn"
                      onClick={() => {
                        handleOpen();
                      }}
                    >
                      SAVE AND SUBMIT
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="container">
        <div className="row mb-4">
          <div className="col-lg-12">
            <div className="content-box ">
              <h2 className="text-dark content-title">
                Washington State LLC Registration
              </h2>
              <p>
                The following form contains questions needed for the formation
                of an LLC in Washington. It is divided into sections and asks
                questions to provide us the information necessary for:
              </p>
              <p>1. Filing an LLC Certificate of Formation; and</p>
              <p>2. Making an "Initial Report."</p>
              <p>
                Please reach out to Kamelia at{"{"}" "{"}"}
                <a href="" className="text-decoration-none">
                  admin@foundrylawgroup.com
                </a>
                {"{"}" "{"}"}
                with any questions on completing the form.
              </p>
              <span className="d-block">Thanks,</span>
              <span>Foundry Law Group</span>
            </div>

            <div className="content-box pt-4">
              <form>
                <div className="mb-3">
                  <label className="form-label">
                    Please enter the email address where you would like to
                    receive updates about your submission:<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={submissionUpdates}
                    onChange={handleSubmissionUpdates}
                    readOnly={readOnly}
                  />
                  {!submissionUpdatesValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {submissionUpdatesValidation.message}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Enter the name of your company below (to be followed with ",
                    LLC").<span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={companyWithLLC}
                    onChange={handleCompanyWithLLC}
                    readOnly={readOnly}
                  />
                  {!companyWithLLCValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {companyWithLLCValidation.message}
                    </div>
                  )}
                  <span>
                    E.g., Company Name, LLC. For an LLC, "Inc." is not allowed
                    in a name however it must contain the words "limited
                    liability company," or the abbreviation "L.L.C" or "LLC."
                    Please note we will check for the names but it's good to
                    provide a couple of alternates.
                  </span>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    What is going to be the LLC's primary business?
                    <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={primaryBusiness}
                    onChange={handlePrimaryBusiness}
                    readOnly={readOnly}
                  />
                  {!primaryBusinessValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {primaryBusinessValidation.message}
                    </div>
                  )}
                  <span>
                    Please describe the business and the goods and/or services
                    you intend to provide (e.g., online retailing, business
                    consulting, etc.)
                  </span>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Who are going to the initial "managers" of the LLC? (See the
                    note below on who should be listed as a manager of an LLC.)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={businessManagers}
                    onChange={handleBusinessManagers}
                    readOnly={readOnly}
                  />
                  {!businessManagersValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {businessManagersValidation.message}
                    </div>
                  )}
                  <span>
                    A manager of a multi-member LLC is equivalent to the members
                    of a board of director or executive officers of a
                    corporation. These are individuals who have general
                    authority to act on behalf of the LLC, sign contracts, and
                    who are otherwise responsible for the overall business of
                    the LLC. (Note that this is a different definition that the
                    common usage of "manager" as a job title.)
                  </span>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    What will be the principal address of the business?
                    <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={principalAddress}
                    onChange={handlePrincipalAddress}
                    readOnly={readOnly}
                  />
                  {!principalAddressValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {principalAddressValidation.message}
                    </div>
                  )}
                  <span>
                    The place of business is an address for the LLC where the
                    primary business will be conducted. This can be your home
                    address, but will be listed as a public record with the
                    state. The address must be a physical street address. A P.O.
                    Box or PMB will not be accepted. If the address is not in WA
                    State, please note that other state's business licenses may
                    be required. Please enter the full address, city, state, and
                    zip code.
                  </span>
                </div>
              </form>
            </div>

            <div className="content-box pt-4">
              <form>
                <div className="mb-3">
                  <label className="form-label">
                    Is there a separate mailing address for the business?
                    <span>*</span>
                  </label>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isSeparateMailingAddress"
                      id="flexRadioDefault4"
                      value={true}
                      checked={isSeparateMailingAddress === "true"}
                      onChange={handleIsSeparateMailingAddress}
                    />

                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isSeparateMailingAddress"
                      id="flexRadioDefault5"
                      value={false}
                      checked={isSeparateMailingAddress === "false"}
                      onChange={handleIsSeparateMailingAddress}
                      disabled={readOnly}
                    />

                    <label className="form-check-label">No</label>
                  </div>
                  {!isSeparateMailingAddressValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {isSeparateMailingAddressValidation.message}
                    </div>
                  )}
                </div>
                {isSeparateMailingAddress === "true" && (
                  <div className="mb-3">
                    <label className="form-label">
                      What will be the mailing address of the business?
                      <span>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      value={mailingAddressForBusiness}
                      onChange={handleMailingAddressForBusiness}
                      readOnly={readOnly}
                    />
                    {!mailingAddressForBusinessValidation.isValid && (
                      <div style={{ color: "red" }}>
                        {mailingAddressForBusinessValidation.message}
                      </div>
                    )}
                  </div>
                )}
                <div className="mb-3">
                  <label className="form-label">
                    What is the preferred contact email for the business?
                    <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={preferredContactEmail}
                    onChange={handlePreferredContactEmail}
                    readOnly={readOnly}
                  />
                  {!preferredContactEmailValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {preferredContactEmailValidation.message}
                    </div>
                  )}
                  <span>A matter of public record</span>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    What is the preferred phone number for the business?
                    <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={preferredPhoneNumber}
                    onChange={handlePreferredPhoneNumber}
                    readOnly={readOnly}
                  />
                  {!preferredPhoneNumberValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {preferredPhoneNumberValidation.message}
                    </div>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Will the effective date for creating the LLC be the date of
                    filing?
                  </label>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isEffectiveDateForCreating"
                      id="flexRadioDefault6"
                      value={true}
                      checked={isEffectiveDateForCreating === "true"}
                      onChange={handleIsEffectiveDateForCreating}
                      disabled={readOnly}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Yes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="isEffectiveDateForCreating"
                      id="flexRadioDefault7"
                      value={false}
                      checked={isEffectiveDateForCreating === "false"}
                      onChange={handleIsEffectiveDateForCreating}
                      disabled={readOnly}
                    />
                    <label className="form-check-label">
                      No (if no, then you must enter a future date below)
                    </label>
                  </div>
                  {!isEffectiveDateForCreatingValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {isEffectiveDateForCreatingValidation.message}
                    </div>
                  )}
                  <span>
                    The default (and most common) effective date for the company
                    is the date of filing. If you would like to specify a
                    different future (cannot be retroactive) date please specify
                    the date and reason for specifying a different date below.
                  </span>
                </div>
                {isEffectiveDateForCreating === "false" && (
                  <>
                    {" "}
                    <div className="mb-3">
                      <label className="form-label">
                        What will be the effective date for the LLC?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={effectiveDateForLLC}
                        onChange={handleEffectiveDateForLLC}
                        readOnly={readOnly}
                      />
                      {!effectiveDateForLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {effectiveDateForLLCValidation.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is the reason for selecting a future effective date
                        for the LLC?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={reasonForEffectiveDate}
                        onChange={handleReasonForEffectiveDate}
                        readOnly={readOnly}
                      />
                      {!reasonForEffectiveDateValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {reasonForEffectiveDateValidation.message}
                        </div>
                      )}
                      <span>
                        A future date for effectiveness is not very common and
                        only appropriate when there is a specific reason, please
                        indicate the reason you would like a future effective
                        date.
                      </span>
                    </div>
                  </>
                )}
                <div className="mb-3">
                  <label className="form-label">
                    By default an LLC is formed to be perpetual (annual renewals
                    still required). In limited cases, a defined term for the
                    LLC may be selected. Please select one of the following
                    option?
                  </label>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="perpetualTermForTheLLC"
                      id="flexRadioDefault6"
                      value={1}
                      checked={perpetualTermForTheLLC === "1"}
                      onChange={handlePerpetualTermForTheLLC}
                      disabled={readOnly}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      Standard perpetual duration
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="perpetualTermForTheLLC"
                      id="flexRadioDefault7"
                      value={2}
                      checked={perpetualTermForTheLLC === "2"}
                      onChange={handlePerpetualTermForTheLLC}
                      disabled={readOnly}
                    />
                    <label className="form-check-label">
                      Time limited (enter time and reason below)
                    </label>
                  </div>
                  {!perpetualTermForTheLLCValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {perpetualTermForTheLLCValidation.message}
                    </div>
                  )}
                  <span>
                    A defined term for an LLC is not typical and only for
                    special circumstances. A standard perpetual term LLC can
                    still be dissolved.
                  </span>
                </div>
                {perpetualTermForTheLLC === "2" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">
                        What would you like to be the term of the LLC (enter in
                        years or a set end date)?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={termOfLLC}
                        onChange={handleTermOfLLC}
                        readOnly={readOnly}
                      />
                      {!termOfLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {termOfLLCValidation.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">
                        What is the reason for selecting a defined term for the
                        LLC?
                        <span>*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={reasonTermOfLLC}
                        onChange={handleReasonTermOfLLC}
                        readOnly={readOnly}
                      />
                      {!reasonTermOfLLCValidation.isValid && (
                        <div style={{ color: "red" }}>
                          {reasonTermOfLLCValidation.message}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </form>
            </div>

            <div className="content-box">
              <h2 className="text-dark content-title">Registered Agent</h2>
              <p>
                All entities must have a Registered Agent in Washington State.
                The Registered Agent can be an individual (such as a member) or
                a service provider. Foundry Law Group offers one year of
                registered agent service as part of our formation package
                ($250/year after the initial year).
              </p>
            </div>

            <div className="content-box pt-4">
              <label>
                Please select a following option for your registered agent.
                <span>*</span>
              </label>
              <div className="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="optionForRegisteredAgent"
                  id="flexRadioDefault1"
                  value={1}
                  checked={optionForRegisteredAgent === "1"}
                  onChange={handleOptionForRegisteredAgent}
                  disabled={readOnly}
                />
                <label className="form-check-label" htmlFor="flexRadioDefault1">
                  Foundry Law Group as Registered Agent (initial year is
                  included in formation flat fee)
                </label>
              </div>
              <div className="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="optionForRegisteredAgent"
                  id="flexRadioDefault2"
                  value={2}
                  checked={optionForRegisteredAgent === "2"}
                  onChange={handleOptionForRegisteredAgent}
                  disabled={readOnly}
                />
                <label className="form-check-label">
                  I'll serve as Registered Agent using the address listed above
                  (Note this address will be publicly listed)
                </label>
              </div>
              <div className="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="optionForRegisteredAgent"
                  id="flexRadioDefault3"
                  value={3}
                  checked={optionForRegisteredAgent === "3"}
                  onChange={handleOptionForRegisteredAgent}
                  disabled={readOnly}
                />
                <label className="form-check-label">
                  Other Registered Agent -NOTE: please fill the next section
                  with name, address, and number
                </label>
              </div>
              {!optionForRegisteredAgentValidation.isValid && (
                <div style={{ color: "red" }}>
                  {optionForRegisteredAgentValidation.message}
                </div>
              )}
              {optionForRegisteredAgent === "3" && (
                <div className="mb-3">
                  <label className="form-label">
                    Other Registered Agent (our preferred vendor is RASi if you
                    would like to use a corporate service provider)
                    <span>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={otherRegisteredAgent}
                    onChange={handleOtherRegisteredAgent}
                    readOnly={readOnly}
                  />
                  {!otherRegisteredAgentValidation.isValid && (
                    <div style={{ color: "red" }}>
                      {otherRegisteredAgentValidation.message}
                    </div>
                  )}
                </div>
              )}
            </div>

            {!readOnly && (
              <div class="d-flex justify-content-center">
                <button class="submit-button btn" onClick={handleSubmit}>
                  Register Your Self And Checkout
                </button>
              </div>
            )}
          </div>
        </div>
      </div> */}
     {/*  <Modal
        open={open}
        onClose={handleCancel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <span onClick={handleCancel} style={{ position: 'absolute', top: 0, right: 0 }}>
        <CloseOutlined />
          </span>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Once you submit this form then you are not able to edit this form.
          </Typography>
          <Typography
            className="text-end"
            id="modal-modal-description"
            sx={{ mt: 2 }}
          >
            <button
              className="btn-submit-secondary btn me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button className="submit-button btn" onClick={handleOk}>
              OK
            </button>
          </Typography>
        </Box>
      </Modal> */}
      <Model2
      centered
        visible={open}
        onCancel={handleCancel}
        footer={[
          <Button
            className="btn-submit-secondary "
            key="back"
            onClick={handleCancel}
          >
            CANCEL
          </Button>,<Button
            className="submit-button "
            key="back"
            onClick={handleOk}
          >
            OK
          </Button>
        ]}
      >
          <div className="row">
            <div className="col">
              <h6>Once you submit this form then you are not able to edit this form.</h6>
            </div>
          </div>
      </Model2>
      <Lodder show={show} />
    </>
  );
};
export default SingleMemberLLCForm;
